/**
 * Shared presentation settings for the advanced-filter modal.
 *
 * Every list page (clients, visits, service requests, doctors, caregivers)
 * spreads ADVANCED_FILTER_MODAL_SETTINGS into its `advancedFilterConfig`, so
 * changing sizing here updates the modal across all pages at once.
 */
import type { AdvancedFilterLayoutConfig } from '@konnecta/generic-table';

/** Row layout inside a filter rule (column / operator / value widths). */
export const ADVANCED_FILTER_LAYOUT: AdvancedFilterLayoutConfig = {
  operatorWidth: '160px',
};

/** Overall modal width. */
export const ADVANCED_FILTER_MODAL_WIDTH = '1000px';

/** Spread into each page's `advancedFilterConfig`. */
export const ADVANCED_FILTER_MODAL_SETTINGS = {
  modalWidth: ADVANCED_FILTER_MODAL_WIDTH,
  layoutConfig: ADVANCED_FILTER_LAYOUT,
} as const;
